import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PasscodeSmsAuthMethodViewModel } from '../../../../services/identity';
import { MethodBase } from '../base/base.component';

@Component({
  selector: 'app-method-passcode-sms',
  standalone: false,
  templateUrl: './passcode-sms.component.html',
  styleUrl: './passcode-sms.component.scss'
})
export class PasscodeSmsComponent extends MethodBase {
  
  
  private passcodeSmsMethod: PasscodeSmsAuthMethodViewModel

  constructor(
    private fb: FormBuilder
  ) {
    super();
  }

  override ngOnInit(): void {   
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();
    if (!this.form.value.phoneNumber && this.options.user.phone) {
      this.form.controls['phoneNumber'].setValue(this.options.user.phone);
    }
  }


  setup(): void {
    this.passcodeSmsMethod = this.method as PasscodeSmsAuthMethodViewModel;
    this.form = this.fb.group({
      phoneNumber: [this.passcodeSmsMethod.phoneNumber, Validators.required]
    });
  }

  cancel(): PasscodeSmsAuthMethodViewModel {
    this.setup();
    return this.method;
  }

  override getMethod(): PasscodeSmsAuthMethodViewModel {
    this.passcodeSmsMethod.phoneNumber = this.form.value.phoneNumber;
    return this.passcodeSmsMethod;
  }
}
